import React, { useState, useRef, useEffect } from 'react';
import * as Yup from 'yup';
import {
	Box,
	Button,
	Text,
	Flex
} from '@chakra-ui/react'
import { InputText, Form, SelectField } from '../../../components/form'
import { toast } from "react-toastify";
import { fetchWrapper } from '../../../helpers';
import { SketchPicker } from 'react-color';

function Create({ meClose, loadList }) {
	const [showColorPicker, setShowColorPicker] = useState(false);
	const [selectedColor, setSelectedColor] = useState('#2563eb');
	const colorPickerRef = useRef(null);

	const [formData, setFormData] = useState({
		name: '',
		color: '#2563eb',
		msg_status: '',
	});

	const FormSchema = Yup.object().shape({
		name: Yup.string().required('Required'),
		color: Yup.string().required('Required'),
		msg_status: Yup.string().required('Required'),
	});

	// Handle clicks outside of the color picker to close it
	useEffect(() => {
		function handleClickOutside(event) {
			if (colorPickerRef.current && !colorPickerRef.current.contains(event.target)) {
				setShowColorPicker(false);
			}
		}
		
		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [colorPickerRef]);

	const handleColorChange = (color) => {
		setSelectedColor(color.hex);
		// Update formData manually since this is outside the form control
		setFormData({
			...formData,
			color: color.hex
		});
	};

	const toggleColorPicker = () => {
		setShowColorPicker(!showColorPicker);
	};

	const onSubmit = async (values, { setSubmitting, resetForm, setStatus }) => {
		// Make sure the color value is updated from our state
		let data = {
			...values,
			color: selectedColor
		};
		
		const url = `${process.env.REACT_APP_API_URL}/status/create`;
		await fetchWrapper.post(url, data);
		loadList();
		meClose();
		toast(`Record has been saved`, {
			type: "info"
		});
	}

	const status_list = {
		data: [
			{ id: 1, name: "Success" },
			{ id: 0, name: "Failed" }
		]
	};

	return (
		<Form
			enableReinitialize
			validationSchema={FormSchema}
			initialValues={formData}
			onSubmit={onSubmit}
		>
			<Box mb="10px">
				<InputText name="name" title="Message Name" inputProps={{ isRequired: true }} placeholder="Enter Message Name" />
			</Box>
			
			<Box mb="10px" className='color-picker-status'>
				<Text  fontWeight="400" fontSize={14}>Message Color <span style={{ color: 'red' }}>*</span></Text>
				<Flex align="center" style={{ marginTop: '10px' }}>
					<Box 
						as="div" 
						w="40px" 
						h="40px" 
						borderRadius="50%" 
						bg={selectedColor}
						cursor="pointer"
						border="1px solid #E2E8F0"
						boxShadow="0 1px 3px rgba(0,0,0,0.12)"
						onClick={toggleColorPicker}
						mr="10px"
					
					/>
					<InputText 
						name="color" 
						inputProps={{ 
							isRequired: true, 
							value: selectedColor,
							onChange: (e) => setSelectedColor(e.target.value),
							width: "120px"
						}} 
						// style={{ marginTop: '10px' }}
						hideLabel
					/>
				</Flex>
				
				{showColorPicker && (
					<Box 
						position="absolute" 
						zIndex="10" 
						mt="5px"
						ref={colorPickerRef}
					>
						<SketchPicker 
							color={selectedColor} 
							onChange={handleColorChange}
							disableAlpha={true}
						/>
					</Box>
				)}
			</Box>
			
			<Box mb="10px">
				<SelectField name="msg_status" title="Message Status" list={status_list} isRequired/>
			</Box>
			
			<Button 
				py="10px" 
				px="25px" 
				color="#fff" 
				bg="#2563eb" 
				fontSize="14px" 
				fontWeight="500" 
				fontFamily="'Open Sans', sans-serif"
				mb={4}
				type='submit'
			>
				Add New Status
			</Button>
		</Form>
	)
}

export default Create;